import {ApolloQueryResult} from 'apollo-client';
export * from '@wandb/weave/common/components/Tags';

export type SaveTags = (tags: string[]) => Promise<ApolloQueryResult<{}>>;
